import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { Database, FileText, FolderOpen, FileCheck, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const quickActions = [
  { label: 'Master Kategori', icon: Database, link: 'ArchiveCategoryList', color: 'bg-blue-600' },
  {
    label: 'Master Jenis Dokumen',
    icon: FileText,
    link: 'DocumentTypeList',
    color: 'bg-purple-600',
  },
  { label: 'Semua Dokumen', icon: FolderOpen, link: 'DocumentList', color: 'bg-amber-600' },
  {
    label: 'Inbox Validasi',
    icon: FileCheck,
    link: 'DocumentValidationInbox',
    color: 'bg-green-600',
  },
];

export default function ArchiveQuickActions() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Akses Cepat</CardTitle>
      </CardHeader>
      <CardContent className="grid md:grid-cols-2 gap-3">
        {quickActions.map(action => (
          <Link key={action.link} to={createPageUrl(action.link)}>
            <Button variant="ghost" className="w-full justify-between hover:bg-gray-50 h-auto p-4">
              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-lg ${action.color} flex items-center justify-center`}
                >
                  <action.icon className="w-5 h-5 text-white" />
                </div>
                <span className="font-medium">{action.label}</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </Button>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
